<template lang="pug">
v-navigation-drawer(v-model="drawer" width="420px" fixed, temporary right)
  .d-flex.ma-4.align-flex-start
    v-btn.rounded.mr-auto(@click="drawer = false" color="secondary" fab tile small)
      v-icon mdi-close
    v-btn.rounded(@click="deleteDialog = true" v-if="canManipulate" color="error" fab tile small)
      v-icon mdi-trash-can
  v-divider
  .pa-4
    p.text-h6.mb-0 Информация о заявке
    v-list(dense).py-0
      v-list-item.px-0
        v-list-item-icon.mr-1
          v-icon mdi-email-outline
          v-list-item-content
            v-list-item-title(v-if="editQuestionEmail")
              v-text-field(dense v-model="editQuestionEmailValue")
            v-list-item-title.text-wrap(v-else) {{ question.email }}
          v-list-item-action.ml-2
            div(v-if="!editQuestionEmail")
              v-btn(icon, @click="editQuestionEmail = !editQuestionEmail")
                v-icon mdi-pencil
              v-btn(icon, @click="copy(question.email)")
                v-icon mdi-clipboard
            div(v-else)
              v-btn(icon @click="saveEditEmail" :disabled="editQuestionEmailValue == question.email")
                v-icon mdi-check
              v-btn(icon @click="editQuestionEmail = !editQuestionEmail")
                v-icon mdi-close

      v-list-item.px-0
        v-list-item-icon.mr-1
          v-icon mdi-web
        v-list-item-content
          v-list-item-title.text-wrap {{ question.page_url }}
        v-list-item-action.ma-0
          v-btn(icon, @click="copy(question.page_url)")
            v-icon mdi-clipboard
      v-list-item.px-0(v-if="question.username")
        v-list-item-icon.mr-1
          v-icon  mdi-account
        v-list-item-content
          v-list-item-title.text-wrap
            | username: {{ question.username }}

      v-list-item.px-0(v-if="question.region_id || question.municipality_id")
        v-list-item-icon.mr-1
          v-icon mdi-map-outline
        v-list-item-content
          v-list-item-title.text-wrap Регион: &nbsp;
            | {{ question.region_id ? cachedRegion(question.region_id).name : region.name }}

      v-list-item.px-0(v-if="question.municipality_id")
        v-list-item-icon.mr-1
          v-icon mdi-map-marker-radius
        v-list-item-content
          v-list-item-title.text-wrap
            | Муниципалитет: {{ cachedMunicipality(question.municipality_id).name || mun.name }}

      v-list-item.px-0
        v-list-item-icon.mr-1
          v-icon mdi-laptop
        v-list-item-content
          v-list-item-title.text-wrap {{ question.user_agent }}
        v-list-item-action.ma-0
          v-btn(icon, @click="copy(question.user_agent)")
            v-icon mdi-clipboard

      v-list-item.px-0(v-if="question.organization_name")
        v-list-item-icon.mr-1
          v-icon mdi-account-outline
        v-list-item-content
          v-list-item-title.text-wrap {{ question.organization_name }}
        v-list-item-action.ma-0
          v-btn(icon, @click="copy(question.organization_name)")
            v-icon mdi-clipboard

      v-list-item.px-0(v-if="question.role_name")
        v-list-item-icon.mr-1
          v-icon mdi-account-circle-outline
        v-list-item-content
          v-list-item-title.text-wrap {{ question.role_name }}
        v-list-item-action.ma-0
          v-btn(icon, @click="copy(question.role_name)")
            v-icon mdi-clipboard

      v-list-item.px-0
        v-list-item-icon.mr-1
          v-icon mdi-alert
        v-list-item-content
          v-list-item-title.text-wrap Тип проблемы: {{ cachedCategory(question.question_category_id).name }}

      v-list-item.px-0(v-if="(history || []).length")
        v-list-item-icon.mr-1
          v-icon mdi-history
        v-list-item-content
          v-list-item-title.text-wrap(
            v-for="(chapter, index) in history"
            :key="index"
          )
            span {{ chapter.name }} : &nbsp;
            span.caption {{ chapter.url }}

      v-list-item.px-0(v-if="question.worker")
        v-list-item-icon.mr-1
          v-icon mdi-account-circle-outline
        v-list-item-content
          v-list-item-title.text-wrap Принят в работу:
            v-chip.ml-2(color="primary" small label) {{question.worker.username}}

  template(v-if="showTransferForm")
    v-divider
    .pa-4(v-if="canManipulate && canPassing")
      v-select(
        v-model="form.role"
        :items="transferRoles"
        :disabled="transferRoles.length === 1"
        label="Кому передать заявку"
        filled
      )
      select-region(
        v-if="form.role !== 'support' && form.role && form.role !== 'operators'"
        v-model="form.region_id"
        filled
        label="Выберите регион"
      )
      select-mun(
        isEmailSettings
        v-if="form.role === 'department'"
        label="Выберите муниципалитет"
        filled
        :disabled="!form.region_id"
        :region="form.region_id"
        v-model="form.municipality_id"
      )
      v-textarea(
        v-model="form.text"
        label="Сообщение передаваемому лицу"
        rows="3"
        filled
      )
      v-btn(
        :disabled="!form.text && !form.role"
        color="primary"
        @click="transferApplication"
        block
      ) Передать заявку

  v-divider
  .pa-4(v-if="transfers.length")
    p.title История передачи
    v-timeline(
      dense
      style="margin-left:-30px"
    )
      v-timeline-item(
        v-for="transfer in transfers"
        :key="transfer.id"
        :color="user.id === transfer.owner_id ? 'success' : 'info'"
      )
        v-card.white--text(:color="user.id === transfer.owner_id ? 'success' : 'info'").pa-4
          p.mb-1.caption {{ transfer.created_at | readableDateTime}}
          v-chip(
            v-for="role in (cachedUser(transfer.owner_id).roles || [])"
            :key="role"
            label
            color="primary"
          ) {{ ROLES_NAMES[role] }}
          span.mx-2 &#10140;
          v-chip(
            v-for="role in (cachedUser(transfer.worker_id).roles || [])"
            :key="role"
            label
            color="primary"
          ) {{ ROLES_NAMES[role] }}

  confirm-form-dialog(
    v-model="deleteDialog"
    message="Действитльно удалить заявку?"
    @accept="deleteQuestion"
  )
</template>

<script>
import SelectMun from '@/components/inputs/SelectMun.vue';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import { showMunicipality, showRegion } from '@/services/API/_common';
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';
import clientQuestionsService from '@/services/API/client-questions';
import { mapActions, mapGetters } from 'vuex';
import { CRUDTransfers } from '@/services/API/_crud';
import { CACHE_KEYS } from '@/store/modules/cache';
import { copyToClipboard } from '@/lib/copyToClipboard';
import { ROLES, ROLES_NAMES } from '@/constants';
import  checkRole  from '@/lib/checkRole';
import mixinDateTime from '@/mixins/mixinDateTime';
import { ACTION_LIST } from '@/modules/User/constants';
import haveRights from '@/lib/haveRights';

const DEFAULT_FORM = {
  text:'',
  role:null,
  municipality_id: null,
  region_id: null,
};
export default {
  components:{
    ConfirmFormDialog,
    SelectMun,
    SelectRegion,
  },
  mixins:[mixinDateTime],
  props:{
    canManipulate: { type: Boolean, required: false, default: false },
    value:{ type:Boolean, required: true },
    question: { type: Object, required: true },
  },
  data() {
    return {
      form: DEFAULT_FORM,

      transfers:[],

      region: {},
      mun: {},
      drawer: false,

      deleteDialog: false,
      ROLES_NAMES,

      editQuestionEmailValue: this.question.email,
      editQuestionEmail: false,
    };
  },
  computed:{
    ...mapGetters({
      'userRole':'auth/userRole',
      'user':'auth/getUser',
      'cachedCategory': 'cache/cachedCategory',
      'cachedRegion': 'cache/cachedRegion',
      'cachedUser': 'cache/cachedUser',
      'cachedMunicipality':'cache/cachedMunicipality',
      'isMunicipality':'auth/isMunicipality',
      'isRegion': 'auth/isRegion',
      'isSupport': 'auth/isSupport',
    }),

    history() {
      return this.question.browser_history;
    },

    transferRoles() {
      if (checkRole(this.userRole, ROLES.municipality)) {
        return [{ text: ROLES_NAMES[ROLES.region], value: ROLES.region }];
      }
      if (checkRole(this.userRole, ROLES.region)) {
        return [
          { text: ROLES_NAMES[ROLES.support], value: ROLES.support },
          { text: ROLES_NAMES[ROLES.municipality], value: ROLES.municipality },
        ];
      }
      if (checkRole(this.userRole, ROLES.support)) {
        return [
          { text: ROLES_NAMES[ROLES.region], value: ROLES.region },
          { text: ROLES_NAMES[ROLES.municipality], value: ROLES.municipality },
        ];
      }
      return [];
    },
    showTransferForm() {
      if (!this.transfers.length) return true;
      return  this.transfers[0]?.owner_id !== this.user.id;
    },

    canPassing() {
      return haveRights(this.user, ACTION_LIST.CAN_PASS_APPLICATION);
    },
  },
  watch:{
    value(v) {
      this.drawer = v;
    },
    drawer(v) {
      this.$emit('input', v);
    },
  },
  async created() {
    await this.fetchRegion();
    await this.fetchTranfers();
    this.form.region_id = this.question.region_id || this.region.id || '';
    this.form.municipality_id = this.question.municipality_id || '';
    if (this.transferRoles.length === 1) {
      this.form.role = this.transferRoles[0].value;
    }
    if (!this.cachedMunicipality(this.question.municipality_id).name) await this.fetchMun();
  },
  methods:{
    ...mapActions({
      'loadToCache': 'cache/loadToCache',
    }),

    async fetchTranfers() {
      const params = {
        'search[client_question_id]': this.question.id,
        'sort':'id',
      };
      try {
        const response = await CRUDTransfers.getAll(params);
        this.transfers = response.data.data;
        const ids = [
          ...this.transfers.map(({ owner_id }) => owner_id),
          ...this.transfers.map(({ worker_id }) => worker_id),
        ];

        await this.loadToCache({ key:CACHE_KEYS.users, ids });
      } catch (error) {
        this.$toast(error.response.data.data.message);
      }
    },

    async fetchRegion() {
      const params = { 'expand':'region' };
      if (this.question.region_id) {
        await this.loadToCache({ key:CACHE_KEYS.regions, ids: [this.question.region_id] });
      }

      const { data:{  data: { region_id } } } = await showMunicipality(this.question.municipality_id, params);

      if (!region_id) return;

      const response = await showRegion(region_id);
      this.region = response.data.data;
    },
    async fetchMun() {
      const response = await showMunicipality(this.question.municipality_id);
      this.mun = response.data.data;
    },
    async deleteQuestion() {
      const params = {
        'client_question_ids': [this.question.id],
      };
      await clientQuestionsService.destroy(params);
      this.$toast.success('Заявка была удалена');
      this.$router.push('/inbox');
    },
    async saveEditEmail() {
      try {
        const params = {
          'email': this.editQuestionEmailValue,
        };
        await clientQuestionsService.update(this.question.id, params);
        this.question.email = this.editQuestionEmailValue;
        this.editQuestionEmail = false;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async transferApplication() {
      const params = {
        'client_question_id': this.question.id,
        ...this.form,
      };
      if (this.form.role === 'operators') delete params.municipality_id;
      if (this.form.role === 'department') delete params.region_id;
      try {
        await CRUDTransfers.create(params);
        this.$toast.success('Заявка была успешно передана');
        this.$router.push('/inbox');
      } catch (error) {
        this.$toast(error.response.data.result_message);
      }
    },
    copy(str) {
      copyToClipboard(str);
      this.$toast.success('Скопировано');
    },
  },

};
</script>

<style>

</style>
